document.addEventListener("DOMContentLoaded", function () {

    const clamps = document.querySelectorAll('.clamp');

    /**
     * Update the clamping state for all clamp elements.
     * This function determines if the content is overflowing
     * and shows/hides the "read more" indicator accordingly.
     */
    function updateClamp() {

        for (const clamp of clamps) {

            const clampContainer = clamp.querySelector('.clamp__container');
            const clampContainerContent = clamp.querySelector('.clamp__container p');
            const clampTrigger = clamp.querySelector('.clamp__more');

            if (!clampContainer || !clampTrigger) continue;

            // If the content is already expanded, no need to display the clampTrigger
            if (clampContainer.classList.contains("clamp__container--expanded")) {
                clampTrigger.style.display = "none";
                continue;
            }

            // Get desired max line count from dataset (fallback 5)
            const lineCount = parseInt(clamp.dataset.line) || 5;

            // Actual content height
            const fullHeight = clampContainer.scrollHeight;

            // Compute height of a single line
            const computed = getComputedStyle(clampContainerContent);
            const lineHeight = parseFloat(computed.lineHeight);

            // Max allowed height before clamping
            const clampHeight = lineHeight * lineCount + lineHeight / 2;

            console.log('Line count * '+lineCount+' = '+clampHeight);
            console.log('Full height: '+fullHeight);
            

            // If content fits in the clamp area → hide clampTrigger
            if (fullHeight <= clampHeight) {
                clampTrigger.style.display = "none";
            } else {
                // Otherwise → show clampTrigger
                clampTrigger.style.display = "block";
            }
        }
    }

    /**
     * Expand handler: clicking on the parent container reveals full content.
     */
    for (const clamp of clamps) {

        const clampContainer = clamp.querySelector('.clamp__container');
        const clampTrigger = clamp.querySelector('.clamp__more');

        if (!clampContainer || !clampTrigger) continue;

        clamp.addEventListener("click", () => {

            // Prevent re-expansion if already expanded
            if (clampContainer.classList.contains("clamp__container--expanded")) return;

            // Apply expanded state
            clampContainer.classList.add("clamp__container--expanded");

            // Hide clampTrigger since content is fully visible
            clampTrigger.style.display = "none";
        });
    }


    /**
     * Debounced resize event: recalculate clamping only when user finishes resizing.
     * This prevents unnecessary reflows and improves performance.
     */
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateClamp, 200);
    });

    // Initial evaluation on page load
    setTimeout(updateClamp, 2000);
});
